import { parseAlarmData } from './parseAlarmData';
export const constructAlarmStreamData = ({ data, }) => {
    return data.map(({ x, y }) => {
        if (typeof y === 'string') {
            return { x, y: parseAlarmData(y) };
        }
        return { x, y };
    });
};
